import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useQuery } from '@tanstack/react-query'
import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { getWorkflowStatus, prettyProduct, prettySpeed } from '../util/helpers'

export function NewestConnectionsCard() {
  const navigate = useNavigate()

  const orderBy = [
    {
      field: 'created',
      order: 'DESC',
    },
  ]

  const encodedOrderBy = encodeURIComponent(JSON.stringify(orderBy))

  const newestConnectionsQuery = useQuery({
    queryKey: ['newestConnections'],

    queryFn: async () => {
      const response = await fetch(`/api/netwerk/aansluitingen?orderBy=${encodedOrderBy}&limit=10`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok)
        throw new Error(response.statusText)

      const json = await response.json()
      return json
    },
  })

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title">Nieuwste aansluitingen</h5>
      </div>
      <div className="card-body">
        {newestConnectionsQuery.isLoading && (
          <div className="alert alert-info" role="alert">
            Loading...
          </div>
        )}
        {newestConnectionsQuery.isError && (
          <div className="alert alert-danger" role="alert">
            Error:
            {' '}
            {(newestConnectionsQuery.error as Error).message}
          </div>
        )}

        {newestConnectionsQuery.data && newestConnectionsQuery.data.total_rows === 0 && (
          <div className="alert alert-info" role="alert">
            Geen aansluitingen gevonden.
          </div>
        )}

        {newestConnectionsQuery.data && newestConnectionsQuery.data.total_rows !== 0 && (
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Bedrijf</th>
                  <th scope="col">Adres</th>
                  <th scope="col">Type</th>
                  <th scope="col">Snelheid</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {newestConnectionsQuery.data?.result.map((connection: any) => (
                  <tr key={connection.connection.id} onDoubleClick={() => navigate(`/netwerkbeheer/aansluitingen/${connection.connection.id}`)}>
                    <td>
                      {connection.company.name}
                      {connection.connection.isCollectionBuilding && (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id={`verzamelgebouw-${connection.connection.id}`}>Verzamelgebouw</Tooltip>}
                        >
                          <span className="ms-2">
                            <FontAwesomeIcon icon={faBuilding as IconProp} className="text-info" />
                          </span>
                        </OverlayTrigger>
                      )}
                    </td>
                    <td>{connection.adres.street}</td>
                    <td>{prettyProduct(connection.connection.type)}</td>
                    <td>{prettySpeed(connection.connection.speed)}</td>
                    <td>{getWorkflowStatus(connection.connection.workflow.status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
